import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useState } from "react";
import AppContext from "src/context/appContext";
import { getSchool } from "src/services/auth/token";

const queryConfig = {
  queries: {
    refetchOnWindowFocus: false,
    retry: false,
    staleTime: 1000 * 60,
  },
};

export const AppProvider = ({ children }) => {
  const [queryClent] = useState(() => {
    return new QueryClient({
      defaultOptions: queryConfig,
    });
  });

  const [schoolSlug, setSchoolSlug] = useState(
    getSchool() ? "/" + getSchool() : ""
  );

  const schoolSlugWithoutPath = getSchool();

  const contextValues = { schoolSlug, setSchoolSlug, schoolSlugWithoutPath };

  return (
    <QueryClientProvider client={queryClent}>
      <AppContext.Provider value={contextValues}>
        {children}
      </AppContext.Provider>
    </QueryClientProvider>
  );
};

export default AppProvider;
